import { PersonOutlinedChip } from "../../../../../components/buttons/IconButtons";
import React from "react";
import CustomCard from "../../../../../components/CustomCard";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
*
 * @jobTittle: Full Stack Developer
 */
/**
 * CardListMap component — renders a customizable card layout with an icon on the left
 *
 * @param {string|number} key - Unique key for the component instance (React list key).
 * @param {JSX.Element} body - Content to be displayed in the main section of the card.
 * @param {React.ComponentType|JSX.Element|null} [icon=null] - Optional icon to display in the left section.
 * @param {string} [backgroundColor='background-shades-50'] - Background color class for the entire card.
 * @param {string} [classContainerIcon='maxw-44px'] - Additional classes for the icon container (e.g., sizing or spacing).
 * @param {string} [colIcon='col-2'] - Bootstrap column width for the icon section.
 * @param {string} [colBody='col-10'] - Bootstrap column width for the body section.
 *
 * @returns {JSX.Element} Rendered CardListMap component.
 */
const CardListMap = ({key, body, icon, backgroundColor='background-shades-50', classContainerIcon='maxw-44px background-primary-100', colIcon = 'col-2',
    colBody = 'col-10' }) => {

    return (
        <CustomCard key={key} classes={`mb-3 ${backgroundColor}`} classCard={`card-border-8px p-16px`} classContent={`p-0`}>
            <div className={"row gap-3"}>
                <div className={"p-0 m-0 row col-12 justify-content-start"}>
                    <div className={`p-0 m-0 ${colIcon}`}>
                        <div className={`p-8px border-radius-8px justify-content-center d-flex ${classContainerIcon}`}>
                            {icon ? icon : <PersonOutlinedChip className="btn-icon-svg-24px" />}
                        </div>
                    </div>
                    <div className={`p-0 m-0 d-flex flex-column justify-content-start gap-1  ${colBody}`}>
                        {body}
                    </div>
                </div>
            </div>
        </CustomCard>
    )
}

export default CardListMap
